export default __webpack_public_path__ + "static/media/BlackLand.0e1204bf.png";